import { INavItems } from 'types/components/Common/navTabs.types';

export const DEFAULT_ROLES = {
  DS_COMPANY_SUPER_ADMIN: 'DS - Super Admin',
  COMPANY_SUPER_ADMIN: 'Company - Super Admin',
};

export const VIEW_ONLY_MESSAGE =
  'You do not have permission, please contact your admin for more information';

export const SETTING_NAV_ITMES: INavItems[] = [
  {
    id: 'profile',
    name: 'Profile',
    url: '/settings/team/profile',
  },
  {
    id: 'roles',
    name: 'Roles',
    url: '/settings/team/profile',
  },
  {
    id: 'configure',
    name: 'Configure',
    url: '/settings/team/configure',
  },
  {
    id: 'integrations',
    name: 'Integrations',
    url: '/settings/team/integrations',
  },
];

export const SELECTED_SETTING_NAV_ITEM = 'roles';

export const PRODUCT = 'general';
